import { render, staticRenderFns } from "./contentWatch.vue?vue&type=template&id=3e06f522&scoped=true&"
import script from "./contentWatch.vue?vue&type=script&lang=js&"
export * from "./contentWatch.vue?vue&type=script&lang=js&"
import style0 from "./contentWatch.vue?vue&type=style&index=0&id=3e06f522&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e06f522",
  null
  
)

export default component.exports